<!-- 詳細情報出力オブジェクトリスト(画面表示情報)分ループ-->
<ng-container *ngFor="let outputGenerateDisplay of outputGenerateDisplayList">
  <!-- 詳細情報出力領域 -->
  <p-table
    [value]="outputGenerateDisplay.generateDisplay"
    styleClass="p-datatable-sm"
  >
    <!-- 詳細情報タイトル -->
    <ng-template pTemplate="header">
      <tr class="p-col-2">
        <th colspan="2">{{ outputGenerateDisplay.title }}</th>
      </tr>
    </ng-template>
    <!-- 詳細情報出力箇所 -->
    <ng-template pTemplate="body" let-generateDisplayInformation>
      <tr>
        <!-- カラム名称 -->
        <td class="table-body-label">
          {{ generateDisplayInformation.column_name }}
        </td>

        <!-- カラムデータ -->
        <!-- データ判定 -->
        <!-- プライマリーキーの場合 -->
        <td
          class="table-body-data"
          *ngIf="'P' == generateDisplayInformation.column_pkey; else notPkey"
        >
          {{ generateDisplayInformation.data }}
        </td>

        <!-- プライマリーキー以外の場合 -->
        <ng-template #notPkey>
          <!-- カラム判定 -->
          <td
            class="table-body-data"
            [ngSwitch]="generateDisplayInformation?.input_type"
          >
            <span *ngSwitchCase="'NUMBER'">
              <!-- 数値の場合 -->

              <span
                *ngIf="
                  generateDisplayInformation.column_id == 'item_code' ||
                    generateDisplayInformation.column_id == 'delivery_id';
                  else PkExcepting
                "
              >
                {{ generateDisplayInformation.data }}
              </span>
              <!-- 特定カラムID以外の場合 -->
              <ng-template #PkExcepting>
                {{ generateDisplayInformation.data | number }}
              </ng-template>
            </span>
            <span *ngSwitchCase="'IMAGE'">
              <!-- 画像の場合 -->
              <img [src]="generateDisplayInformation.data" alt="image" />
            </span>
            <span *ngSwitchCase="'FILE'">
              <!-- ファイルの場合 -->
              <div class="ui-fluid p-d-flex">
                <!-- ファイル名-->
                <label class="fileName">
                  {{ generateDisplayInformation.data.name }}
                </label>
                <!-- ファイルDL-->
                <button
                  pButton
                  label="ダウンロード"
                  [value]="generateDisplayInformation.data.url"
                  onClick="location.href=this.value"
                  class="p-mr-2 downloadButton"
                  [disabled]="!generateDisplayInformation.data.url"
                ></button>
              </div>
            </span>
            <span *ngSwitchCase="'URL'">
              <!-- URLの場合 -->
              <a [href]="generateDisplayInformation.data.url" target="_blank">
                {{ generateDisplayInformation.data.name }}
              </a>
            </span>
            <span *ngSwitchDefault>
              <!-- 上記以外の場合の場合 -->
              {{ generateDisplayInformation.data }}
            </span>
          </td>
        </ng-template>
      </tr>
    </ng-template>
  </p-table>
  <!-- 改行 -->
  <br />
</ng-container>
